export default __webpack_public_path__ + "static/media/scroll.cf3c1122.gif";